import React from 'react';
import { cn } from '@restworld/utils-common';

import { focusRing } from '../styles/focus-ring';

export const selectLabelStyle = 'flex justify-between items-center text-neutral-700 text-base font-medium mb-2';
export const selectSecondaryLabelStyle = 'text-sm font-normal text-neutral-100';
export const selectInteractiveAreaStyle = `appearance-none h-12 relative w-full border border-neutral-90 cursor-pointer flex items-center justify-between rounded-lg bg-neutral-10 py-3 px-4 text-left transition duration-200 ease-in-out hover:bg-neutral-30 ${focusRing} disabled:bg-neutral-40`;
export const selectInteractiveAreaContentStyle = 'text-base font-medium text-neutral-700';
export const selectOptionsStyle =
  'max-h-[305px] xl:max-h-[360px] overflow-auto rounded-lg z-[200] bg-neutral-10 p-2 text-base border border-neutral-90 shadow-[0px_4px_16px_0px_rgba(0,0,26,0.25)]';
export const selectOptionStyle =
  'relative cursor-pointer select-none py-0 px-5 h-12 flex items-center text-base text-neutral-700 font-medium hover:bg-neutral-30 hover:rounded-lg';
export type HelperTextVariantType = 'error' | 'info' | 'success';

export function SelectMainWrapper({
  children,
  className,
}: {
  fullwidth?: boolean; // kept for backward compatibility, now always full-width
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn('w-full', className)}>{children}</div>;
}

export function ListboxContentWrapper({ children }: { children: React.ReactNode }) {
  return <div className="relative mt-1">{children}</div>;
}

export function SecondaryLabel({ children }: { children?: React.ReactNode }) {
  return <span className={selectSecondaryLabelStyle}>{children}</span>;
}

export function ListboxButtonContent({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <span className={cn(selectInteractiveAreaContentStyle, 'inline-block truncate pr-2', className)}>{children}</span>
  );
}

export function IconAndTextWrapper({ children }: { children: React.ReactNode }) {
  return <span className="flex items-center gap-2">{children}</span>;
}

export function ArrowIconWrapper({
  isOpen,
  children,
  className,
}: {
  isOpen?: boolean;
  children: React.ReactNode;
  className?: string;
}) {
  return <span className={cn('min-w-[24px] transition-transform', isOpen && 'rotate-180', className)}>{children}</span>;
}

export function StyledSelectHelperText({
  variant,
  children,
}: {
  variant?: HelperTextVariantType;
  children: React.ReactNode;
}) {
  return (
    <span
      className={cn(
        'text-sm font-normal mt-2 inline-block',
        variant === 'error' ? 'text-red-500' : variant === 'success' ? 'text-green-500' : 'text-neutral-700'
      )}
    >
      {children}
    </span>
  );
}

export function StyledPlaceholder({ children }: { children: React.ReactNode }) {
  return <span className="text-base font-normal text-neutral-200">{children}</span>;
}
